/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { Pagination } from '../models/Pagination';
import { SensitivityAnnotation } from '../models/SensitivityAnnotation';

export class ListSensitivityAnnotationsResponse {
  'sensitivityAnnotations': Array<SensitivityAnnotation>;
  'pagination': Pagination;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "sensitivityAnnotations",
      "baseName": "sensitivityAnnotations",
      "type": "Array<SensitivityAnnotation>",
      "format": ""
    },
    {
      "name": "pagination",
      "baseName": "pagination",
      "type": "Pagination",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListSensitivityAnnotationsResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

